import { useMemo } from 'react';
import { Tag } from 'antd';
import { FaUserClock, FaUserCheck, FaUserTimes } from 'react-icons/fa';

export const useConversionStatusRender = () => {
  return useMemo(() => {
    return (type: string) => {
      const typeConfigs: {
        [key: string]: {
          bgColor: string;
          textColor: string;
          borderColor: string;
          icon: React.ReactNode;
          text: string;
        };
      } = {
        CONVERTED: {
          bgColor: '#e6f7ff',
          textColor: '#1890ff',
          borderColor: '#91d5ff',
          icon: <FaUserCheck />,
          text: 'T-Converted',
        },
        NOT_CONVERTED: {
          bgColor: '#f9f0ff',
          textColor: '#722ed1',
          borderColor: '#d3adf7',
          icon: <FaUserTimes />,
          text: 'T-Not Converted',
        },
      };

      const config = typeConfigs[type] || {
        bgColor: '#f5f5f5',
        textColor: '#8c8c8c',
        borderColor: '#d9d9d9',
        icon: <FaUserClock />,
        text: type,
      };

      return (
        <Tag
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '6px',
            fontWeight: 500,
            padding: '4px 8px',
            borderRadius: '6px',
            lineHeight: '1.2',
            backgroundColor: config.bgColor,
            color: config.textColor,
            border: `1px solid ${config.borderColor}`,
          }}
        >
          <span style={{ display: 'flex', alignItems: 'center' }}>
            {config.icon}
          </span>
          <span>{config.text}</span>
        </Tag>
      );
    };
  }, []);
};
